module.exports = __webpack_public_path__ + "assets/images/magenta_sport_3.1470402ec37e76f5d7754302ce250c6b.png";